import React, { useMemo } from 'react';

import PageContainer from 'components/PageContainer';
import TrialReminder from 'components/TrialReminder';

import { ContentType, Story } from 'graphql/generated/graphql';

import { IntlMsgShape } from 'helpers/consts';

import CourseHeader from './CourseHeader';
import CourseAudioList from './CourseList';
import CourseRecommendations from './CourseRecommendations';
import { calculateTotalStoriesAudioLength } from './helpers';

import './style.scss';

export type AudioCourseStory = Pick<
  Story,
  | 'actions'
  | 'alreadyListened'
  | 'description'
  | 'durationInMinutes'
  | 'id'
  | 'title'
  | 'transcodedAudioUrl'
  | 'transcodedSampleUrl'
> & { contentType: Pick<ContentType, 'slug'> };

interface ClassesDetailsProps {
  title: IntlMsgShape;
  description: IntlMsgShape;
  illustration: {
    src: string;
    alt: IntlMsgShape;
  };
  audios: AudioCourseStory[];
}

const AudioCourse = ({
  title,
  description,
  illustration,
  audios,
}: ClassesDetailsProps) => {
  const calculateTotalLength = useMemo(() => {
    return calculateTotalStoriesAudioLength(audios);
  }, [audios]);

  return (
    <PageContainer>
      <div className="AudioCourse">
        <CourseHeader
          headerIllustration={illustration}
          title={title}
          description={description}
          numberOfAudios={audios.length}
          totalCourseLength={calculateTotalLength}
        />
        <CourseAudioList stories={audios} />

        <TrialReminder showCTA />

        <CourseRecommendations />
      </div>
    </PageContainer>
  );
};

export default AudioCourse;
